import { CultureOption, CurrencyOption, SupportedPreferences } from "$graphql/core";
import { ParsedUserPreferences } from "$types";

export interface SelectedPreferences {
    selectedLocale: CultureOption;
    selectedCurrency: CurrencyOption;
}

export const getSelectedPreferences = (
    supportedPreferences: SupportedPreferences,
    userPreferences: ParsedUserPreferences,
    isBenchmarkingSubscriber: boolean
): SelectedPreferences => {
    const selectedLocale = supportedPreferences.cultures?.find(
        culture => culture?.value === userPreferences.CultureName
    ) || { id: 1, name: "English", subtext: "United States", value: "en-US" };

    const selectedCurrency = supportedPreferences.currencies?.find(
        currency => currency?.value === userPreferences.CurrencyName
    ) || { id: 1, name: "United States Dollar", subtext: "USD - $", value: "USD" };

    const selectedBenchmarkCulture = isBenchmarkingSubscriber
        ? supportedPreferences.benchmarkCultures?.find(
              culture => culture?.value === userPreferences.STROverrideCulture
          ) || null
        : null;

    return {
        selectedLocale: selectedBenchmarkCulture ?? selectedLocale,
        selectedCurrency,
    };
};
